<template>
  <component :is="`el-${item.type}`" :item="item" :optionList="optionList" v-bind="$attrs" v-on="$listeners"></component>
</template>

<script>
//import Enum from "@/utils/enum.js";
//import Verifi from "@/utils/verifications.js";
const allComponents = require.context("./copn", false, /\.vue$/);
let res_components = {};
allComponents.keys().forEach((fileName) => {
  let comp = allComponents(fileName);
  res_components[fileName.replace(/^\.\//, "").replace(/\.\w+$/, "")] = comp.default;
});

export default {
  props: {
    item: Object,
    optionList: Array,
  },
  /* eslint-disable */
  components: {
    ...res_components,
  },
  // data() {
  //   return {
  //     rules: (this.item.rules && this.buildRules(this.item.rules)) || [],
  //   };
  // },
  // methods: {
  //   buildRules(rules) {
  //     let back = [];
  //     for (let i = 0; i < rules.length; i++) {
  //       let rule = rules[i];
  //       for (let key in rule) {
  //         back.push(Verifi[Enum[key]](rule[key]));
  //       }
  //     }
  //     return back;
  //   },
  // },
};
</script>

<style lang="scss" scoped></style>
